import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value.billing_address)?_c(VExpansionPanels,{attrs:{"flat":"","value":0}},[_c(VExpansionPanel,[_c(VExpansionPanelHeader,{staticClass:"text-h6"},[_vm._v(" "+_vm._s(_vm.$t('Billing address'))+" ")]),_c(VExpansionPanelContent,[_c('orderable-address-preview',{attrs:{"value":_vm.value.billing_address}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }